<template>
  <b-container fluid class="container container-vende-tu-auto">

    <div class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center ">
        <img class="step-desktop" src="../assets/imgs/desktop/desktop_reagendamiento_reagendado.png" alt="AUTOCOM" />
        <img class="step-tablet" src="../assets/imgs/tablet/tablet_reagendamiento_reagendado.png" alt="AUTOCOM" />
        <img class="step-mobile" src="../assets/imgs/mobile/movil_reagendamiento_reagendado.png" alt="AUTOCOM" />
      </div>
    
    <div class="row justify-content-center">
      <div class="col-sm-12 text-center">
      </div>

      <div class="container container-info" >
        <div class="container-vende-view">
      <div class="content-va">

      <div class="col-md-12 text-center margin-inspeccion">

        <div class="oferta-tituloinfo"> <h4 class="titulo-reagendamiento"> Esta es tu oferta y los nuevos datos del agendamiento <br> para la inspección.</h4> </div>

        <div class="titulo-mobile marcaModeloAño oferta-infoauto">{{ año }} <span class="black">{{ marca }} {{ modelo }}</span></div>
        <div class="versionColorKm versionColorKm-aux">{{ version }} <span class="pipe">|</span> {{ color }} <span class="pipe">|</span> {{ kmComputedString }} KM</div>
        <div class="titulo-mobile nofolio">
          <h4 class="titulo-nofolio">NO. FOLIO: {{ folio }}</h4>
        </div>

        <div class="mejorOfertaMobile border-mejor-oferta">
          <h4 class="mejor-oferta">EL RANGO DE TU <br> MEJOR OFERTA <b>GARANTIZADA</b> ES</h4>
            <b-col>
              <h5 class="oferta"> <span class="ofertaLight">DE</span> ${{ formatPrice(this.ofertaMin) }}.00* <span class="ofertaLight">A</span> ${{ formatPrice(this.ofertaMax) }}.00*</h5>
            </b-col>
        </div>

          <p class="texto-oferta mt-2">
              Esta oferta es válida hasta el {{ this.validezVA }}<br />*La oferta puede variar después
              de la inspección del vehículo
          </p>



        <div v-if="this.tipoInspeccion !== 'domicilio'" class="row justify-content-md-center">
          <div class="row col-12">
            <div class="col-6 right-2"><h3 class="info-cita">Fecha:</h3></div>
            <div class="col-6 left-2"><h3 class="info-cita" style="color:black;">{{this.fecha}}</h3></div>
            <div class="col-6 right-2"><h3 class="info-cita">Hora:</h3></div>
            <div class="col-6 left-2"><h3 class="info-cita" style="color:black;">{{this.hora}} hrs.</h3></div>
            <div class="col-6 right-2"><h3 class="info-cita">Lugar de inspección:</h3></div>
            <div class="col-6 left-2"><h3 class="info-cita" style="color:black;">{{this.agencia}} <br> {{this.domicilio}}</h3></div>
          </div>
        </div>

        <div v-if="this.tipoInspeccion === 'domicilio'" class="row col-12">
          <div class="col-6 right-2">
            <h3 class="info-cita">Domicilio donde te visitaremos:</h3>
          </div>
          <div class="col-6 left-2">
            <h3 class="info-cita"><span style="color:black;">{{this.domicilio}}</span></h3>            
          </div>
        </div>

        <p class="texto-oferta mt-2">
          Si quieres modificar la cita para la inspección <span class="enlace " @click="prueba()">haz clic aquí</span>
        </p>

        <div class="text-center mt-3 print">
              <a href="javascript:window.print()"><img src="../assets/imgs/ico-print.svg" class="imgImp"  fluid><span class="text-imprimir"> Imprimir confirmación </span></a>
        </div>        
      </div>
    </div>
    </div></div>
    </div>
  </b-container>
</template>

<script>

export default {
  name: "Inspeccion",

  components: {},

  data() {
    return {
      nombre: sessionStorage.getItem("nombre"),
      apellidos: sessionStorage.getItem("apellidos"),
      marca: sessionStorage.getItem("marca"),
      modelo: sessionStorage.getItem("modelo"),
      año: sessionStorage.getItem("anio"),
      oferta: sessionStorage.getItem("oferta"),
      ofertaMin: "",
      ofertaMax: "",
      folio: sessionStorage.getItem("idvaloration"),
      agencia: sessionStorage.getItem("sucursalAgenda"),
      fecha: sessionStorage.getItem("fechaAgenda"),
      hora: sessionStorage.getItem("horaAgenda"),
      domicilio: sessionStorage.getItem("direccionAgencia"),
      tipoInspeccion: sessionStorage.getItem("tipoInspeccion"),
      validezVA: sessionStorage.getItem("fecha_validez"),
      tipoAgendamiento: sessionStorage.getItem("tipoAgendamiento"),
      version: sessionStorage.getItem("version"),
      color: sessionStorage.getItem("color"),
      color: sessionStorage.getItem("color"),
      kmComputedString: sessionStorage.getItem("kilometraje"),
    };
  },

  methods: {
    paginaPrincipal(){
      setTimeout(() => {
        this.$router.push({ path: "/" });
      }, 150);
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    ofertas(){
      this.ofertaMin = (this.oferta - (this.oferta * .10));
      //this.ofertaMax = (Number(this.oferta) + (this.oferta * .02));
      this.ofertaMax = this.oferta;
    },

    prueba(){
      this.$router.push({ path: "/Reagendamiento?vafolio="+this.folio });
    },
  },

  created(){
    this.ofertas();
  },

  onMounted(){
    window.scrollTo(0, 0)
  },

  computed: {
    validez(){
      let d=new Date();
      d.setDate(d.getDate()+8);
      let a= d.toLocaleDateString('es-pa').split("/");
      return a[1]+"/"+a[0]+"/"+a[2];
    }
  },

};
</script>
<style>
.mejorOferta {
  display: flex;
  height: 128px;
  background-color: #51555c;
  align-items: center;
  justify-content: center;
}

.mejorOferta h5 {
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700 !important;
  font-size: 40px;
  color: #fff;
}

.mejorOferta h6 {
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  color: #fff;
}

.marcaModelo {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  color: #51555C;
  margin-bottom: 20px;
}

</style>